import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-nss',
  templateUrl: './nss.component.html',
  styleUrls: ['./nss.component.scss']
})
export class NssComponent implements OnInit {
  showAlert=false;
  showSuccess=false;
  constructor() { }

  ngOnInit(): void {
  }

  onSubmit(form:NgForm){
    if(form.invalid){
      this.showAlert=true;
      return;
    }
    this.showSuccess=true;
    form.reset();
  }
}
